import { z } from 'zod';
import { LEAFLINK_ORDER_FILTER_STATUSES } from '../../constants/leaflink-order-filter-statuses.js';
import { LEAFLINK_ORDERS_FILTER_TEXT_MAX_LENGTH } from '../../constants/leaflink-orders-filter-text-max-length.js';
import { isCalendarDate } from '../../dates/calendar-date.js';
const trimmedOrAbsent = z
    .string()
    .nullish()
    .transform((value) => value?.trim() || undefined);
function filterText(label) {
    return trimmedOrAbsent.pipe(z
        .string()
        .max(LEAFLINK_ORDERS_FILTER_TEXT_MAX_LENGTH, `${label} must be ${LEAFLINK_ORDERS_FILTER_TEXT_MAX_LENGTH} characters or fewer.`)
        .optional());
}
function filterDate(label) {
    return trimmedOrAbsent.pipe(z
        .string()
        .refine((value) => isCalendarDate(value), `${label} must be a valid date (YYYY-MM-DD).`)
        .optional());
}
export const leafLinkOrdersFilterArgsSchema = z
    .object({
    orderNumber: filterText('Order number'),
    customerName: filterText('Customer name'),
    statuses: z
        .array(z.enum(LEAFLINK_ORDER_FILTER_STATUSES, { error: 'Unknown order status.' }))
        .max(LEAFLINK_ORDER_FILTER_STATUSES.length, `Choose at most ${LEAFLINK_ORDER_FILTER_STATUSES.length} statuses.`)
        .nullish()
        .transform((statuses) => (statuses?.length ? [...new Set(statuses)] : undefined)),
    paid: z
        .boolean()
        .nullish()
        .transform((paid) => paid ?? undefined),
    createdFrom: filterDate('Created from'),
    createdTo: filterDate('Created to'),
})
    .superRefine((filters, context) => {
    if (filters.createdFrom && filters.createdTo && filters.createdFrom > filters.createdTo) {
        context.addIssue({
            code: 'custom',
            path: ['createdTo'],
            message: 'Created from must be on or before Created to.',
        });
    }
});
//# sourceMappingURL=leaflink-orders-filter-args-schema.js.map